import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

import { Loader } from 'theSource/components';
import {
  LifeEventBodyContainerStyled,
  LifeEventButtonContainerStyled,
  LifeEventButtonStyled,
  LifeEventButtonWrapperStyled,
  LifeEventContainerStyled,
} from './LifeEventBoxStyled';
import { useLifeEventQuery } from 'enrollment/queries';
import { LifeEventDto } from 'enrollment/queries/useLifeEventQuery/types';
import { ROUTES } from 'theSource/app/routes';

export const LifeEventBox = () => {
  const { t } = useTranslation('pages.home');
  const navigate = useNavigate();
  const [lifeEvents, setLifeEvents] = useState<LifeEventDto[]>([]);

  const { data, isLoading, isFetching } = useLifeEventQuery({
    enabled: true,
  });

  const startLifeEvent = (id: number | undefined) => {
    navigate(`/${ROUTES.lifeEvent.path}`, {
      state: {
        selected: id,
      },
    });
  };

  useEffect(() => {
    if (data) {
      const firstFive = data.data.org_life_events.slice(0, 5);
      setLifeEvents(firstFive);
    }
  }, [data]);

  if (isLoading || isFetching) {
    return <Loader />;
  }

  return (
    <LifeEventContainerStyled data-testid="life-event-box-container">
      <LifeEventBodyContainerStyled>
        <h3 className="w-100">{t('lifeEventTitle')}</h3>
        <Box sx={{ height: '7px' }} />
        <LifeEventButtonContainerStyled>
          {lifeEvents.map((lifeEvent, index) => (
            <LifeEventButtonWrapperStyled $isThird={(index + 1) % 3 === 0}>
              <LifeEventButtonStyled
                id={String(lifeEvent.org_life_event_id)}
                onClick={() => startLifeEvent(lifeEvent.org_life_event_id)}
              >
                {lifeEvent.name.length > 38
                  ? `${lifeEvent.name.slice(0, 34)}...`
                  : lifeEvent.name}
              </LifeEventButtonStyled>
            </LifeEventButtonWrapperStyled>
          ))}
          <LifeEventButtonWrapperStyled $isThird={true}>
            <LifeEventButtonStyled
              id="other_btn"
              onClick={() => startLifeEvent(undefined)}
            >
              {t('otherOption')}
            </LifeEventButtonStyled>
          </LifeEventButtonWrapperStyled>
        </LifeEventButtonContainerStyled>
      </LifeEventBodyContainerStyled>
    </LifeEventContainerStyled>
  );
};
